import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import Image from 'react-bootstrap/Image';
import { UserProfile } from 'modules/auth/store/userAPI';

import * as URL from 'lib/router/url';
import { isTokenExpired } from 'lib/api';
import { useComponentDidMount } from 'modules/core/hooks';
import * as partnersActions from 'modules/partners/store/actions';
import { GglSpinner } from 'modules/core/components/spinner';
import LazyImage from 'modules/core/components/lazy_load/LazyImage';

import './styles.css';

import * as actions from './store/actions';
import SignIn from './SignIn';

interface LoginHomePageProps {
  loading?: boolean
  user?: UserProfile
  resetError?(...args: unknown[]): unknown
  logo?: string
  getLogo?(...args: unknown[]): unknown
}

const LoginHomePage = (props: LoginHomePageProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    loading,
    user,
    resetError,
    logo,
    getLogo,
  } = props;

  //    const items = ['photo-12', 'photo-02', 'photo-09', 'photo-08', 'photo-10'];
  const items = ['photo-01', 'photo-02', 'photo-03', 'photo-04', 'photo-05', 'photo-06',
    'photo-07', 'photo-08', 'photo-09', 'photo-10', 'photo-11', 'photo-12'];
  const rnd = Math.floor(Math.random() * items.length);
  const hiRes = `/assets/backgrounds/${ items[rnd] }.jpg`;
  // const loRes = `/assets/backgrounds/${ items[rnd] }LR.jpg`;

  useComponentDidMount(() => {
    resetError();
    if (user?.email && !isTokenExpired(user?.token)) {
      const query = queryString.parse(location.search);

      navigate(query?.redirectTo ? query.redirectTo : URL.URL_HOME);
    }
  });

  useComponentDidMount(() => {
    getLogo();
  });

  return (
    <div className='homepage_container'>
      <div className='homepage_auth'>
        <br />
        { logo && (
          <Image className='homepage_logo' src={ logo } />
        ) }

        <div className='homepage_form'>
          { loading ? (
            <GglSpinner overlay />
          ) : (
            <SignIn />
          ) }
        </div>
      </div>

      <LazyImage
        src={ hiRes }
        // srcLow={ loRes }
        className='homepage_img'
        type='DIV'
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.auth?.loading,
    user: state.auth?.profile,
    logo: state.partners?.logo?.logoUrl,
  };
};

const mapDispatchToProps = dispatch => ({
  resetError: () => dispatch(actions.resetError()),
  getLogo: () => dispatch(partnersActions.getLogo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginHomePage);
